import { render, staticRenderFns } from "./GeneralManagement.vue?vue&type=template&id=b313d86e&scoped=true"
import script from "./GeneralManagement.vue?vue&type=script&lang=js"
export * from "./GeneralManagement.vue?vue&type=script&lang=js"
import style0 from "./GeneralManagement.vue?vue&type=style&index=0&id=b313d86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b313d86e",
  null
  
)

export default component.exports